module.exports = __webpack_public_path__ + "img/attack_special.e8825e39.png";